<template>
  <div class="share--catalog-container" v-if="user && !loading">
    <v-card class="share--catalog">
      <div class="share--left-side">
        <div class="share--title">
          {{ $t('general.yourCatalogLink') }}
        </div>
        <div class="share--link">
          <a :href="`${catalogUrl}`" target="_blank">
            {{ catalogUrl }}
          </a>
        </div>
      </div>
      <div class="share--button">
        <share :social-url="catalogUrl"></share>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Share from '@/components/utils/share.vue';

export default {
  components: { Share },
  props: [],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
      totalCoins: (state) => state.coins.totalCoins,
      membershipAction: (state) => state.global.membershipAction,
    }),
    ...mapGetters({
      membershipType: 'global/membershipType',
    }),
    catalogUrl() {
      return process.env.VUE_APP_USER_URL + this.user?.catalog_url;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('coins/getTotalCoins'),
        this.$store.dispatch('listingAvailability/getListingAvailability'),
        this.$store.dispatch('global/getMembershipAction'),
      ]);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    handleContact() {
      let url = '';
      const contactNumber = '+' + this.$t('general.phone2');
      const text =
        'Halo, saya butuh informasi lebih lanjut mengenai promo perpanjangan early bird.';
      url = `https://wa.me/${contactNumber}?text=${text}`;

      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';
.share--catalog-container {
  min-width: 33%;
  position: relative;
  @media #{$phones} {
    width: 100% !important;
  }
}
.share--catalog {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-radius: 30px !important;
  @media #{$phones} {
    padding: 20px 28px;
  }
  .share--left-side {
    max-width: calc(100% - 48px);
  }
  .share--title {
    font-family: Poppins-SemiBold, sans-serif;
    font-size: $font-ml;
    margin-bottom: 8px;
  }
  .share--link {
    font-family: Poppins-SemiBold, sans-serif;
  }
  .share--button {
    cursor: pointer;
    margin-left: 12px;
    .v-icon {
      color: $color-beliruma-1;
      font-size: 36px;
    }
  }
}
</style>
